import { type FloatingPopoverType } from '@/defs/floating'
import { useModalProps } from '@/hooks/useModalProps'
import { stripProps } from '@/utils/commonUtil'

import { FloatingModal } from '../../FloatingModal/FloatingModal'

export const FloatingModalTrigger = ({ children, ...props }: FloatingPopoverType) => {
  const popoverProps = stripProps(props, ['ignoreScopes', 'onInteractOutside', 'placement', 'width'])
  const modalProps = useModalProps()

  return <FloatingModal {...popoverProps} {...modalProps} trigger={children} />
}
